import "./TheLab.module.css";
import NavigationHub from "@/reusable_sections/Header";
import OurDna from "./sections/OurDna";
import TheGrowthFormula from "./sections/TheGrowthFormula";
import LeadScientists from "./sections/LeadScientists";
import TheLabFooter from "@/reusable_sections/Footer";
export default function TheLabPage() {
  return <div>
      <NavigationHub />
      <OurDna />
      <TheGrowthFormula />
      <LeadScientists />
      <TheLabFooter />
    </div>;
}